const PageContainer = ({ children, className = "" }) => {
  return (
    <div className={`w-full max-w-[1580px] mx-auto ${className}`.trim()}>
      {children}
    </div>
  );
};

export default PageContainer;
